__turbopack_context__.v({
  "titleWrapper": "style-module-scss-module__Ezscdq__titleWrapper",
  "wrapper": "style-module-scss-module__Ezscdq__wrapper",
});
